import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';

const LabelDataSchema = z.object({
  labelColor: z.string().regex(/^#[A-Fa-f0-9]{6}$/),
  labelName: z.string(),
});

const LabelSchema = LabelDataSchema.extend({
  identifier: z.string(),
  companyId: z.string(),
});

export const labelContract = createRESTContract({
  getLabels: {
    method: 'GET',
    path: 'label',
    response: LabelSchema.array(),
    body: z.undefined(),
    permissions: [PERMISSIONS.LABEL.LABEL_LIST],
  },
  createLabel: {
    method: 'POST',
    path: 'label',
    response: LabelSchema,
    body: LabelDataSchema,
    permissions: [PERMISSIONS.LABEL.LABEL_CREATE],
  },
  updateLabel: {
    method: 'PUT',
    path: 'label/:labelId',
    response: z.void(),
    body: LabelDataSchema,
    permissions: [PERMISSIONS.LABEL.LABEL_EDIT],
  },
  removeLabel: {
    method: 'DELETE',
    path: 'label/:labelId',
    response: z.void(),
    body: z.undefined(),
    permissions: [PERMISSIONS.LABEL.LABEL_REMOVE],
  },
});
